import { SentryReportInterceptor } from '@fs/http'
import customizeHeaderInterceptor from './customizeHeaderInterceptor'
import mrInterceptor from './mrInterceptor'
import outsideH5LogoutInterceptor from './outsideH5LogoutInterceptor'
import cmhkLogoutInterceptor from './cmhkLogoutInterceptor'
import freezeAccountInterceptor from './freezeAccountInterceptor'
import { getLangType, isTHSApp } from '@/utils/tools'
import { getXSource } from '../http.tool'
import { getRunEnv } from '@/utils/env'
import { isHLApp } from '@fs/utils'
import thsLogoutInterceptor from './thsLogoutInterceptor'
import CommonHeadersInterceptor from '@fs/http/dist/lib/http/FSH5Http/commonHeaders'
import ECDHEncryptInterceptor from '@fs/http/dist/lib/http/FSH5Http/encryptInterceptors/ECDHEncryptInterceptor'
import ECDHDecryptInterceptor from '@fs/http/dist/lib/http/FSH5Http/decryptInterceptors/ECDHDecryptInterceptor'
import LOGINEncryptInterceptor from '@fs/http/dist/lib/http/FSH5Http/encryptInterceptors/LOGINEncryptInterceptor'
import LOGINDecryptInterceptor from '@fs/http/dist/lib/http/FSH5Http/decryptInterceptors/LOGINDecryptInterceptor'
import { captureException } from '@sentry/vue'

const { VUE_APP_ENV, NODE_ENV, VUE_APP_PUBLIC_KEY, VUE_APP_SIGN_KEY } = process.env

let store = null

export default function (http) {
    try {
        const ECDHKeys = {
            PUBLIC_KEY: VUE_APP_PUBLIC_KEY,
            SIGN_KEY: VUE_APP_SIGN_KEY,
        }

        http.registerInterceptor(
            'request',
            LOGINEncryptInterceptor({
                VUE_APP_ENV: VUE_APP_ENV,
            })
        )
        http.registerInterceptor('request', ECDHEncryptInterceptor(ECDHKeys))

        http.registerInterceptor('request', customizeHeaderInterceptor)

        // uin、session、lang、xSource、rndKey
        const sessionKey = getRunEnv() === 2 ? 'WTtoken' : 'session'
        const session = () => localStorage.getItem(sessionKey) || ''
        const uin = () => localStorage.getItem('uin') || ''
        const rndKey = () => localStorage.getItem('rndKey') || ''
        http.registerInterceptor(
            'request',
            CommonHeadersInterceptor({
                uin,
                session,
                rndKey,
                lang: getLangType(),
                xSource: getXSource(),
                product: 'pages',
                NODE_ENV,
            })
        )

        http.registerInterceptor('request', async config => {
            if (!store) {
                store = (await import('@/store/login'))?.default
            }
            return config
        })

        http.registerInterceptor('response', ECDHDecryptInterceptor(ECDHKeys))
        http.registerInterceptor('response', LOGINDecryptInterceptor({ NODE_ENV }))
        http.registerInterceptor('response', SentryReportInterceptor(captureException, true))

        // 处理冻结
        http.registerInterceptor('response', freezeAccountInterceptor)
        if (!isHLApp()) {
            http.registerInterceptor('response', mrInterceptor)
            http.registerInterceptor('response', outsideH5LogoutInterceptor)
            http.registerInterceptor('response', cmhkLogoutInterceptor({ store }))
            http.registerInterceptor('response', thsLogoutInterceptor)
        }
    } catch (e) {
        console.log(`Feng.chen:: 16:20:43 e ===> `, e)
    }
}
